<template>
  <v-content>
    <v-container fill-height justify-center class="primary" fluid>
      <router-view />
    </v-container>
  </v-content>
</template>

<script>
export default {};
</script>
